import React from "react";
import { Input } from "reactstrap";

const QueueAttendenceSearch = ({ onChangeSearch, placeholder }) => {
  return (
    <div className="search-box chat-search-box flex-grow-1">
      <div className="position-relative">
        <Input
          id="searchInput"
          type="text"
          className="form-control"
          placeholder={placeholder}
          autoComplete="off"
          onChange={onChangeSearch}
        />
        <i className="bx bx-search-alt search-icon"></i>
      </div>
    </div>
  );
};
export default QueueAttendenceSearch;
